import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function HubSpotTrack ()
{
	const location = useLocation();

	useEffect(() =>
	{
		if (!(window as any)._hsq)
		{
			(window as any)._hsq = [];
		}
		(window as any)._hsq.push(['setPath', location.pathname]);

		// wait for the page to load and update document.title
		setTimeout(() =>
		{
			(window as any)._hsq.push(['trackPageView']);
		}, 500);

	}, [location]);

	return null;
}
